import { Skeleton } from '@/components/ui/skeleton';

/** Global pending component (spec §4.2). */
export function RoutePending() {
  return (
    <div className="flex flex-col gap-3 p-6">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
